<script>
    import { createEventDispatcher } from 'svelte'
    import BigIcon from '../../components/Icons/BigIcon.svelte'
    // import SidepanelButton from '../../components/SidepanelLink/SidepanelButton.svelte'
    // import PeriodSelector from '../../components/PeriodSelector/PeriodSelector.svelte'
    import SearchQuery from '../../components/SearchQuery/SearchQuery.svelte'
    import MonthSelector from '../../components/PeriodSelector/MonthSelector.svelte'
    import SidepanelSelect from '../../components/SidepanelFields/SidepanelSelect.svelte'

    export let data 
    
    const dispatch = createEventDispatcher ();

    let queryType = '',
        operatorId = '',
        monthId = '',
        operators = [],
        queryTypes = [
            {
                text: 'Attività / Operatore',
                value: 'op-activity'
            },
            {
                text: 'Straordinari / Mese',
                value: 'month-overtime'
            }
        ]

    const onQuerytypeChange = (event) => {
        queryType = event.detail;
        // console.log ('onQuerytypeChange', event.detail);
    }

    const onOperatorChange = (event) => {
        operatorId = event.detail;
    }

    const onMonthChange = (event) => {
        monthId = event.detail;
    }

    const generateQuery = (event) => {
        let queryBuilder = {}
        queryBuilder.type = queryType;
        queryBuilder.operator = operatorId
        queryBuilder.month = monthId

        dispatch ('query', queryBuilder)
    }


    $: {
        if (data.operators) {
            operators = data.operators.map (it => {
                return {
                    text: it.name,
                    value: it.token_id
                }
            }).sort ((a, b) => {
                return a.text < b.text ? -1 : 1;
            })
            operators.unshift ({
                text: 'Scegli Operatore',
                value: -1
            });
        }
    }

    $: buttonEnabled = queryType === 'op-activity' && operatorId !== '' && operatorId !== '-1' || queryType === 'month-overtime'
</script>

<style>
    .SidepanelContent {
        padding: 25px 20px 20px 20px;
    }
    .SidepanelContent .icon-holder {
        text-align: center;
        margin-bottom: 10px;
    }
    .SidepanelContent .meta {
        text-align: center;
        margin-bottom: 20px;
    }
    .SidepanelContent .meta .label {
        font-size: 18px;
        font-weight: 600;
    }
    .SidepanelContent .meta .text {
        font-size: 13px;
        color: var(--text-secondary);
        line-height: 14px;
    }
    .SidepanelContent .time-range {
        margin-top: 10px;
    }
    .SidepanelContent .query-type {
        margin-top: 10px;
    }
    .SidepanelContent .ctrls {
        margin-top: 10px;
    }
    .SidepanelContent .ctrls button {
        width: 100%;
    }
</style>

<div class="SidepanelContent">
    <div class="icon-holder">
        <BigIcon icon="fad fa-search"  />
    </div>
    {#if data}
        <div class="meta">
            <div class="label">Query Attivit&agrave;</div>
            <div class="text">--</div>
        </div>
        
        <!-- <div class="search">
            <SearchQuery on:search />
        </div> -->
        <div class="query-type">
            <SidepanelSelect items={queryTypes} on:select={onQuerytypeChange} />
        </div>

        {#if queryType === 'op-activity'}
            <div class="query-type">
                <SidepanelSelect items={operators} value={-1} on:select={onOperatorChange} />
            </div>
        {/if}

        <div class="time-range">
            <MonthSelector on:month-change={onMonthChange} />
            <!-- <PeriodSelector {start} {end} on:period-change /> -->
        </div>

        {#if buttonEnabled}
            <div class="ctrls">
                <button class="btn btn-sm btn-primary" on:click={generateQuery}>Inizia Query</button>
            </div>
        {/if}
    {/if}
</div>